import { withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1fe91675"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "feedback-container" }
const _hoisted_2 = {
  key: 0,
  class: "feedback-menu",
  ref: "feedbackMenu"
}
const _hoisted_3 = { class: "header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header-text" }, "Feedback", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-x" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 0,
  class: "feedback-options"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 0,
  class: "damage-disclaimer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DriverFeedbackForm = _resolveComponent("DriverFeedbackForm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["feedback-icon", { active: _ctx.isActive }]),
      onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args)), ["stop"])),
      ref: "questionButton"
    }, " ? ", 2),
    (_ctx.isActive === true)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", {
              class: "exit",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeMenu && _ctx.closeMenu(...args)))
            }, _hoisted_6)
          ]),
          (!_ctx.selectedOption)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.feedbackOptions, (feedbackOption, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: i,
                    class: "feedback-option",
                    onClick: _withModifiers(($event: any) => (_ctx.onRowClick(i)), ["stop"])
                  }, [
                    _createElementVNode("div", null, _toDisplayString(feedbackOption), 1),
                    (i === _ctx.isDamageOption && _ctx.isSwiftDriver)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, " This feedback does not replace a macro 38 "))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_8))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_ctx.selectedOption !== null)
            ? (_openBlock(), _createBlock(_component_DriverFeedbackForm, {
                key: 1,
                feedbackOption: _ctx.selectedOption,
                onOnNavigateBack: _ctx.resetFeedbackSelection,
                onOnSubmit: _ctx.sendFeedback
              }, null, 8, ["feedbackOption", "onOnNavigateBack", "onOnSubmit"]))
            : _createCommentVNode("", true)
        ], 512))
      : _createCommentVNode("", true)
  ]))
}